module.exports = __webpack_public_path__ + "img/top2.4efa83f4.png";